import { render } from "./ParentIndex.vue?vue&type=template&id=39ad316e"
import script from "./ParentIndex.vue?vue&type=script&lang=js"
export * from "./ParentIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__